
import Vue from "vue";
import Router from "vue-router";
import index from "@/view/index/index";

Vue.use(Router);

const router = new Router({
	mode: "hash",
	// mode: "history",
	// base: "/pc/",//文都
	routes: [
		//登录
		{
			path: "/login",
			name: "login",
			component: () => import("@/view/login/login.vue"),
			meta: {
				title: "文都医学欢迎您"
			}
		},
		//首页
		{
			path: "/",
			name: "index",
			component: index,
			meta: {
				title: "文都医学"
			}
		},
		//关于我们
		{
			path: "/aboutUs",
			name: "aboutUs",
			component: () => import("@/view/aboutUs/index.vue"),
			meta: {
				title: "关于我们"
			}
		},
		//师资
		{
			path: "/teachers",
			name: "teachers",
			component: () => import("@/view/teachers/index.vue"),
			meta: {
				title: "师资"
			}
		},
		// 图书商城
		{
			path: "/bookMall",
			name: "bookMall",
			component: () => import("@/view/bookMall/index.vue"),
			meta: {
				title: "图书商城"
			}
		},
		// 图书详情
		{
			path: "/bookDetail",
			name: "bookDetail",
			component: () => import("@/view/bookMall/bookDetail.vue")
		},
		//课程列表
		{
			path: "/courseList",
			name: "courseList",
			component: () => import("@/view/course/courseList/courseList.vue"),
			meta: {
				title: "课程"
			}
		},
		//课程详情
		{
			path: "/courseDetail",
			name: "courseDetail",
			component: () => import("@/view/course/courseDetail/courseDetail.vue")
		},
		//面授课程详情
		{
			path: "/faceCourseDetail",
			name: "faceCourseDetail",
			component: () => import("@/view/course/faceCourseDetail/faceCourseDetail.vue")
		},
		//课程目录
		{
			path: "/courseCatalog",
			name: "courseCatalog",
			component: () => import("@/view/course/components/courseCatalog.vue")
		},
		//学习中心
		{
			path: "/learningCenter",
			name: "learningCenter",
			component: () => import("@/view/learningCenter/index.vue"),
			meta: {
				title: "学习中心"
			}
		},
		//视频播放
		{
			path: "/video",
			name: "video",
			component: () => import("@/view/video/video.vue")
		},
		//备考资讯
		{
			path: "/testPreparationInformation",
			name: "testPreparationInformation",
			component: () => import("@/view/testPreparationInformation/index.vue"),
			meta: {
				title: "备考资讯"
			}
		},
		// 备考资讯详情
		{
			path: "/testPreparationInformationDetail",
			name: "testPreparationInformationDetail",
			component: () =>
				import(
					"@/view/testPreparationInformation/testPreparationInformationDetail.vue"
				)
		},
		// 购物车
		{
			path: "/shopingCart",
			name: "shopingCart",
			component: () => import("@/view/shopingCart/shopingCart.vue"),
			meta: {
				title: "购物车"
			}
		},
		// 创建订单
		{
			path: "/createOrder",
			name: "createOrder",
			component: () => import("@/view/createOrder/createOrder.vue"),
			meta: {
				title: "创建订单"
			}
		},
		// 修改地址
		{
			path: "/createDialog",
			name: "createDialog",
			component: () => import("@/view/createOrder/createDialog.vue"),
			meta: {
				title: "修改地址"
			}
		},
		// 我的订单
		{
			path: "/myOrder",
			name: "myOrder",
			component: () => import("@/view/myOrder/myOrder.vue"),
			meta: {
				title: "我的订单"
			}
		},
		// 课程相关规定协议页面
		{
			path: "/classAgreement",
			name: "classAgreement",
			component: () => import("@/view/course/classAgreement/classAgreement.vue"),
			meta: {
				title: "课程相关规定协议"
			}
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		};
	}
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err => err);
};

router.beforeEach((to, from, next) => {
	// ...
	if (to.name === "shopingCart" || to.name === "createOrder") {
		try {
			let token = window.localStorage.getItem("token");
			if (!token) {
				if (to.meta.title) {
					document.title = to.meta.title;
				}
				next({
					name: "login"
				});
			} else {
				if (to.meta.title) {
					document.title = to.meta.title;
				}
				next();
			}
		} catch (err) {
			if (to.meta.title) {
				document.title = to.meta.title;
			}
			next();
		}
	} else {
		if (to.meta.title) {
			document.title = to.meta.title;
		}
		next();
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js